import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, CheckCircle, AlertCircle, Clock, Filter, Search, Building, Car, Calendar, Euro, RefreshCw, Download, Loader2, Edit3, X, Save, Send, CheckSquare, History, Newspaper, Upload } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

function AdminMultas() {
  const [multas, setMultas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [filtroEmpresa, setFiltroEmpresa] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [busquedaDebounced, setBusquedaDebounced] = useState('');
  const [empresas, setEmpresas] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 50, total: 0, totalPages: 0 });
  const [stats, setStats] = useState({ total: 0, identificadas: 0, pendientes: 0, comunicadas: 0 });
  const navigate = useNavigate();
  const { usuario, loading: authLoading } = useAuth();
  const [filtroDocs, setFiltroDocs] = useState('');
  const [ordenCol, setOrdenCol] = useState('created_at');
  const [ordenDir, setOrdenDir] = useState('DESC');

  // Sync URL params to filter state (on mount and on URL change)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlEstado = params.get('estado');
    const urlDocs = params.get('docs');
    if (urlEstado) setFiltroEstado(urlEstado);
    if (urlDocs) setFiltroDocs(urlDocs);
  }, []);

  // Modal completar datos
  const [modalMulta, setModalMulta] = useState(null);
  const [datosForm, setDatosForm] = useState({
    codigo_notificacion: '',
    importe_multa: '',
    concepto: '',
    articulo: '',
    puntos: ''
  });
  const [guardando, setGuardando] = useState(false);

  // Modal comunicar manual
  const [comunicarModal, setComunicarModal] = useState(null);
  const [comunicarForm, setComunicarForm] = useState({ numero_registro: '', observaciones: '' });
  const [comunicarArchivo, setComunicarArchivo] = useState(null);
  const [comunicando, setComunicando] = useState(false);

  // Enviar al organismo (via signing-service)
  const [enviandoOrganismo, setEnviandoOrganismo] = useState({});

  // Historial modal
  const [historialModal, setHistorialModal] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);
  const [subiendoDocumento, setSubiendoDocumento] = useState(false);
  const [subiendoPdf, setSubiendoPdf] = useState({});

  // Modal cambiar identificación
  const [identificacionModal, setIdentificacionModal] = useState(null);
  const [identificacionForm, setIdentificacionForm] = useState({
    tipo_identificacion: 'conductor',
    conductor_dni: '', conductor_nombre: '',
    conductor_apellido1: '', conductor_apellido2: '',
    conductor_direccion: '', conductor_codigo_postal: '',
    conductor_poblacion: '', conductor_provincia: '',
    empresa_cesionaria_cif: '', empresa_cesionaria_razon_social: '',
    empresa_cesionaria_domicilio: '', empresa_cesionaria_codigo_postal: '',
    empresa_cesionaria_poblacion: '', empresa_cesionaria_provincia: '',
    empresa_cesionaria_num_contrato: ''
  });
  const [guardandoIdentificacion, setGuardandoIdentificacion] = useState(false);

  const abrirIdentificacionModal = (multa) => {
    setIdentificacionModal(multa);
    setIdentificacionForm({
      tipo_identificacion: multa.tipo_identificacion === 'empresa_cesionaria' ? 'empresa_cesionaria' : 'conductor',
      conductor_dni: multa.conductor_dni || '',
      conductor_nombre: multa.conductor_nombre || '',
      conductor_apellido1: multa.conductor_apellido1 || '',
      conductor_apellido2: multa.conductor_apellido2 || '',
      conductor_direccion: multa.conductor_direccion || '',
      conductor_codigo_postal: multa.conductor_codigo_postal || '',
      conductor_poblacion: multa.conductor_poblacion || '',
      conductor_provincia: multa.conductor_provincia || '',
      empresa_cesionaria_cif: multa.empresa_cesionaria_cif || '',
      empresa_cesionaria_razon_social: multa.empresa_cesionaria_razon_social || '',
      empresa_cesionaria_domicilio: multa.empresa_cesionaria_domicilio || '',
      empresa_cesionaria_codigo_postal: multa.empresa_cesionaria_codigo_postal || '',
      empresa_cesionaria_poblacion: multa.empresa_cesionaria_poblacion || '',
      empresa_cesionaria_provincia: multa.empresa_cesionaria_provincia || '',
      empresa_cesionaria_num_contrato: multa.empresa_cesionaria_num_contrato || ''
    });
  };

  const guardarIdentificacion = async () => {
    try {
      setGuardandoIdentificacion(true);
      // BUG-023: sanitizar payload según el tipo seleccionado. Antes se enviaba formData completo
      // incluido conductor_dni residual con CIF al cambiar de Conductor → Empresa, y Joi rechazaba.
      const tipo = identificacionForm.tipo_identificacion;
      const payload = { tipo_identificacion: tipo };
      if (tipo === 'conductor') {
        Object.assign(payload, {
          conductor_dni: identificacionForm.conductor_dni,
          conductor_nombre: identificacionForm.conductor_nombre,
          conductor_apellido1: identificacionForm.conductor_apellido1,
          conductor_apellido2: identificacionForm.conductor_apellido2,
          conductor_direccion: identificacionForm.conductor_direccion,
          conductor_codigo_postal: identificacionForm.conductor_codigo_postal,
          conductor_poblacion: identificacionForm.conductor_poblacion,
          conductor_provincia: identificacionForm.conductor_provincia,
        });
      } else if (tipo === 'empresa_cesionaria') {
        Object.assign(payload, {
          empresa_cesionaria_cif: identificacionForm.empresa_cesionaria_cif,
          empresa_cesionaria_razon_social: identificacionForm.empresa_cesionaria_razon_social,
          empresa_cesionaria_domicilio: identificacionForm.empresa_cesionaria_domicilio,
          empresa_cesionaria_codigo_postal: identificacionForm.empresa_cesionaria_codigo_postal,
          empresa_cesionaria_poblacion: identificacionForm.empresa_cesionaria_poblacion,
          empresa_cesionaria_provincia: identificacionForm.empresa_cesionaria_provincia,
          empresa_cesionaria_num_contrato: identificacionForm.empresa_cesionaria_num_contrato,
        });
      } else if (tipo === 'otros') {
        // Gestión externa: no hay datos de identificación, solo el motivo del cierre
        if (!identificacionForm.motivo_externo) {
          alert('Selecciona el motivo por el que la multa se gestionó fuera de la plataforma.');
          setGuardandoIdentificacion(false);
          return;
        }
        Object.assign(payload, {
          motivo_externo: identificacionForm.motivo_externo,
          observaciones_externo: identificacionForm.observaciones_externo || '',
        });
      }
      await api.put(`/admin/multas/${identificacionModal.id}/identificacion`, payload);
      setIdentificacionModal(null);
      cargarMultas();
    } catch (error) {
      // BUG-019: leer details[] del backend para mostrar errores específicos en lugar de "Validación fallida"
      const data = error.response?.data;
      if (data?.details && Array.isArray(data.details) && data.details.length > 0) {
        const errores = data.details.map(d => `• ${d.field || 'campo'}: ${d.message}`).join('\n');
        alert(`No se pudo guardar — errores de validación:\n\n${errores}`);
      } else {
        alert(data?.error || 'Error al actualizar identificación');
      }
    } finally {
      setGuardandoIdentificacion(false);
    }
  };

  // Comunicacion masiva
  const [seleccionadas, setSeleccionadas] = useState(new Set());
  const [comunicarMasivoModal, setComunicarMasivoModal] = useState(false);
  const [comunicarMasivoForm, setComunicarMasivoForm] = useState({ observaciones: '' });
  const [comunicandoMasivo, setComunicandoMasivo] = useState(false);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setBusquedaDebounced(busqueda);
      setPagination(prev => ({ ...prev, page: 1 }));
    }, 400);
    return () => clearTimeout(timer);
  }, [busqueda]);

  useEffect(() => {
    if (authLoading) return;
    if (usuario?.rol !== 'admin') {
      navigate('/');
      return;
    }
    cargarEmpresas();
  }, [authLoading, usuario]);

  // Reload multas when filters or page change
  useEffect(() => {
    if (authLoading || usuario?.rol !== 'admin') return;
    cargarMultas();
  }, [filtroEstado, filtroEmpresa, busquedaDebounced, filtroDocs, ordenCol, ordenDir, pagination.page]);

  const cargarEmpresas = async () => {
    try {
      const res = await api.get('/admin/empresas');
      setEmpresas(res.data.data || []);
    } catch (error) {
      console.error('Error cargando empresas:', error);
    }
  };

  const cargarMultas = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.set('page', pagination.page);
      params.set('limit', pagination.limit);
      if (filtroEstado !== 'todos') params.set('estado', filtroEstado);
      if (filtroEmpresa) params.set('empresa_id', filtroEmpresa);
      if (busquedaDebounced.trim()) params.set('busqueda', busquedaDebounced.trim());
      if (filtroDocs) params.set('docs', filtroDocs);
      params.set('orden', ordenCol);
      params.set('dir', ordenDir);

      const res = await api.get(`/admin/multas/todas?${params.toString()}`);
      setMultas(res.data.data || []);
      if (res.data.pagination) setPagination(prev => ({ ...prev, ...res.data.pagination }));
      if (res.data.stats) setStats({
        total: parseInt(res.data.stats.total) || 0,
        identificadas: parseInt(res.data.stats.identificadas) || 0,
        pendientes: parseInt(res.data.stats.pendientes) || 0,
        comunicadas: parseInt(res.data.stats.comunicadas) || 0
      });
    } catch (error) {
      console.error('Error cargando multas:', error);
    } finally {
      setLoading(false);
    }
  };

  const cargarDatos = () => {
    cargarEmpresas();
    cargarMultas();
  };

  const abrirModal = (multa) => {
    setModalMulta(multa);
    setDatosForm({
      codigo_notificacion: multa.codigo_notificacion || '',
      importe_multa: multa.importe_multa || '',
      concepto: multa.concepto || '',
      articulo: multa.articulo || '',
      puntos: multa.puntos != null ? multa.puntos : ''
    });
  };

  const cerrarModal = () => {
    setModalMulta(null);
    setDatosForm({ codigo_notificacion: '', importe_multa: '', concepto: '', articulo: '', puntos: '' });
  };

  const guardarDatos = async () => {
    setGuardando(true);
    try {
      await api.put(`/admin/multas/${modalMulta.id}/completar-datos`, datosForm);
      alert('Datos completados correctamente');
      cerrarModal();
      cargarDatos();
    } catch (error) {
      console.error('Error guardando datos:', error);
      alert(error.response?.data?.error || 'Error al guardar los datos');
    } finally {
      setGuardando(false);
    }
  };

  const abrirComunicarModal = (multa) => {
    setComunicarModal(multa);
    setComunicarForm({ numero_registro: '', observaciones: '' });
    setComunicarArchivo(null);
  };

  const comunicarManual = async () => {
    setComunicando(true);
    try {
      const formData = new FormData();
      if (comunicarForm.numero_registro) formData.append('numero_registro', comunicarForm.numero_registro);
      if (comunicarForm.observaciones) formData.append('observaciones', comunicarForm.observaciones);
      if (comunicarArchivo) formData.append('justificante', comunicarArchivo);

      await api.post(`/admin/multas/${comunicarModal.id}/comunicar-manual`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert(comunicarArchivo
        ? 'Multa comunicada correctamente. Se ha subido el justificante del organismo.'
        : 'Multa comunicada correctamente. Se ha generado un justificante PDF interno.'
      );
      setComunicarModal(null);
      setComunicarArchivo(null);
      cargarDatos();
    } catch (error) {
      console.error('Error comunicando multa:', error);
      alert(error.response?.data?.error || 'Error al comunicar la multa');
    } finally {
      setComunicando(false);
    }
  };

  const enviarAlOrganismo = async (multa) => {
    if (!window.confirm(`¿Enviar la multa ${multa.numero_expediente} al organismo via certificado digital?\n\nEsto iniciara la comunicacion automatica con ${multa.organismo_emisor || 'el organismo'}.`)) return;

    setEnviandoOrganismo(prev => ({ ...prev, [multa.id]: 'enviando' }));
    try {
      const res = await api.post(`/dgt/comunicaciones/enviar/${multa.id}`);
      const jobId = res.data?.jobId;
      setEnviandoOrganismo(prev => ({ ...prev, [multa.id]: 'enviado' }));
      alert(`Comunicacion enviada correctamente.${jobId ? `\nJob ID: ${jobId}` : ''}\n\nEl proceso se ejecutara en segundo plano. Consulta el historial para ver el resultado.`);
      setTimeout(() => {
        setEnviandoOrganismo(prev => ({ ...prev, [multa.id]: null }));
        cargarDatos();
      }, 3000);
    } catch (error) {
      console.error('Error enviando al organismo:', error);
      setEnviandoOrganismo(prev => ({ ...prev, [multa.id]: null }));
      alert(error.response?.data?.error || 'Error al enviar la comunicacion al organismo');
    }
  };

  const abrirHistorial = async (multa) => {
    setHistorialModal(multa);
    setCargandoHistorial(true);
    try {
      const res = await api.get(`/multas/${multa.id}/historial`);
      setHistorial(res.data.data || []);
    } catch (error) {
      setHistorial([]);
    } finally {
      setCargandoHistorial(false);
    }
  };

  const subirDocumentoHistorial = async (file) => {
    if (!historialModal || !file) return;
    setSubiendoDocumento(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('descripcion', `Documento adjuntado: ${file.name}`);
      await api.post(`/admin/multas/${historialModal.id}/historial/documento`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      // Refresh historial
      const res = await api.get(`/multas/${historialModal.id}/historial`);
      setHistorial(res.data.data || []);
    } catch (error) {
      alert('Error al subir documento: ' + (error.response?.data?.error || error.message));
    } finally {
      setSubiendoDocumento(false);
    }
  };

  const subirNotificacionPdf = async (multaId, file) => {
    if (!file) return;
    setSubiendoPdf(prev => ({ ...prev, [multaId]: true }));
    try {
      const formData = new FormData();
      formData.append('file', file);
      await api.post(`/admin/multas/${multaId}/notificacion-pdf`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      // Refresh multas to show PDF button
      const res = await api.get('/admin/multas');
      setMultas(res.data.data || []);
    } catch (error) {
      alert('Error al subir PDF: ' + (error.response?.data?.error || error.message));
    } finally {
      setSubiendoPdf(prev => ({ ...prev, [multaId]: false }));
    }
  };

  const getHistorialIcon = (tipo) => {
    switch (tipo) {
      case 'sincronizacion': return { icon: RefreshCw, color: 'text-slate-500', bg: 'bg-slate-100' };
      case 'identificacion': return { icon: CheckCircle, color: 'text-emerald-500', bg: 'bg-emerald-100' };
      case 'comunicacion': return { icon: Send, color: 'text-blue-500', bg: 'bg-blue-100' };
      case 'error': return { icon: AlertCircle, color: 'text-red-500', bg: 'bg-red-100' };
      case 'admin': return { icon: Edit3, color: 'text-purple-500', bg: 'bg-purple-100' };
      case 'pdf_descarga': return { icon: FileText, color: 'text-slate-500', bg: 'bg-slate-100' };
      default: return { icon: Clock, color: 'text-slate-400', bg: 'bg-slate-100' };
    }
  };

  const getResultadoBadge = (resultado) => {
    switch (resultado) {
      case 'ok': return 'bg-emerald-100 text-emerald-700';
      case 'error': return 'bg-red-100 text-red-700';
      case 'pendiente': return 'bg-amber-100 text-amber-700';
      default: return 'bg-slate-100 text-slate-600';
    }
  };

  const formatDateTime = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString('es-ES', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  // Server-side filtering — multas already filtered by backend
  const multasFiltradas = multas;
  const multasElegibles = multasFiltradas;

  const toggleSeleccion = (id) => {
    setSeleccionadas(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const toggleTodas = () => {
    if (multasElegibles.length > 0 && multasElegibles.every(m => seleccionadas.has(m.id))) {
      setSeleccionadas(new Set());
    } else {
      setSeleccionadas(new Set(multasElegibles.map(m => m.id)));
    }
  };

  const comunicarMasivo = async () => {
    setComunicandoMasivo(true);
    try {
      const res = await api.post('/admin/multas/comunicar-masivo', {
        multa_ids: Array.from(seleccionadas),
        observaciones: comunicarMasivoForm.observaciones || null
      });
      const { exitosos, fallidos, errores } = res.data.data;

      let msg = `Comunicadas: ${exitosos}`;
      if (fallidos > 0) msg += `\nFallidas: ${fallidos}`;
      if (errores.length > 0) msg += `\n\nErrores:\n` + errores.map(e => `- Multa ${e.multaId}: ${e.error}`).join('\n');
      alert(msg);

      setSeleccionadas(new Set());
      setComunicarMasivoModal(false);
      setComunicarMasivoForm({ observaciones: '' });
      cargarDatos();
    } catch (error) {
      alert(error.response?.data?.error || 'Error al comunicar las multas');
    } finally {
      setComunicandoMasivo(false);
    }
  };

  // Stats come from server now

  const getEstadoBadge = (estado) => {
    switch (estado) {
      case 'conductor_identificado':
        return { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Identificada', icon: CheckCircle };
      case 'comunicado_organismo':
        return { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Comunicada', icon: FileText };
      case 'pendiente_identificacion':
        return { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Pendiente', icon: Clock };
      default:
        return { bg: 'bg-slate-100', text: 'text-slate-700', label: estado, icon: AlertCircle };
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('es-ES');
  };

  const formatCurrency = (amount) => {
    if (!amount) return '-';
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  // Descarga Excel
  const [descargandoExcel, setDescargandoExcel] = useState(false);

  const descargarExcel = async () => {
    setDescargandoExcel(true);
    try {
      const params = new URLSearchParams();
      if (filtroEstado !== 'todos') params.set('estado', filtroEstado);
      if (filtroEmpresa) params.set('empresa_id', filtroEmpresa);
      if (busqueda) params.set('busqueda', busqueda);

      const response = await api.get(`/admin/multas/exportar-excel?${params.toString()}`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `multas-${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error descargando Excel:', error);
      alert('Error al descargar el Excel');
    } finally {
      setDescargandoExcel(false);
    }
  };

  // Estado para descarga de justificantes
  const [descargando, setDescargando] = useState({});

  // Función para descargar justificante
  const descargarJustificante = async (multaId, expediente) => {
    setDescargando(prev => ({ ...prev, [multaId]: true }));
    try {
      const response = await api.get(`/dgt/justificante/${multaId}`);
      if (response.data.success && response.data.download_url) {
        window.open(response.data.download_url, '_blank');
      } else {
        alert(response.data.error || 'No se pudo obtener el justificante');
      }
    } catch (error) {
      console.error('Error descargando justificante:', error);
      const mensaje = error.response?.data?.error || 'Error al descargar el justificante';
      alert(mensaje);
    } finally {
      setDescargando(prev => ({ ...prev, [multaId]: false }));
    }
  };

  // Estado y función para descargar PDF BOE
  const [descargandoBoe, setDescargandoBoe] = useState({});

  const descargarBoePdf = async (multaId) => {
    setDescargandoBoe(prev => ({ ...prev, [multaId]: true }));
    try {
      const response = await api.get(`/dgt/boe/pdf-by-multa/${multaId}`);
      if (response.data.success && response.data.download_url) {
        window.open(response.data.download_url, '_blank');
      } else {
        alert(response.data.error || 'No se pudo obtener el PDF del BOE');
      }
    } catch (error) {
      console.error('Error descargando BOE PDF:', error);
      const mensaje = error.response?.data?.error || 'Error al descargar el PDF del BOE';
      alert(mensaje);
    } finally {
      setDescargandoBoe(prev => ({ ...prev, [multaId]: false }));
    }
  };

  // Estado y función para descargar escrito de identificación
  const [descargandoEscrito, setDescargandoEscrito] = useState({});

  const descargarEscrito = async (multaId) => {
    setDescargandoEscrito(prev => ({ ...prev, [multaId]: true }));
    try {
      const response = await api.get(`/dgt/escrito/${multaId}`);
      if (response.data.success && response.data.download_url) {
        window.open(response.data.download_url, '_blank');
      } else {
        alert(response.data.error || 'No se pudo obtener el escrito');
      }
    } catch (error) {
      console.error('Error descargando escrito:', error);
      const mensaje = error.response?.data?.error || 'Error al descargar el escrito';
      alert(mensaje);
    } finally {
      setDescargandoEscrito(prev => ({ ...prev, [multaId]: false }));
    }
  };

  // Estado y función para descargar PDF de notificación DGT
  const [descargandoNotificacion, setDescargandoNotificacion] = useState({});

  const descargarNotificacionPdf = async (multaId) => {
    setDescargandoNotificacion(prev => ({ ...prev, [multaId]: true }));
    try {
      const response = await api.get(`/dgt/notificacion-pdf/${multaId}`);
      if (response.data.success && response.data.download_url) {
        window.open(response.data.download_url, '_blank');
      } else {
        alert(response.data.error || 'No se pudo obtener el PDF de notificación');
      }
    } catch (error) {
      console.error('Error descargando notificación PDF:', error);
      const mensaje = error.response?.data?.error || 'Error al descargar el PDF de notificación';
      alert(mensaje);
    } finally {
      setDescargandoNotificacion(prev => ({ ...prev, [multaId]: false }));
    }
  };

  if (authLoading || loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-slate-600">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white/80 backdrop-blur-lg shadow-soft border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/admin/dashboard')} className="p-2 hover:bg-slate-100 rounded-xl transition-colors">
              <ArrowLeft className="w-6 h-6 text-slate-600" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-slate-900 font-display">Todas las Multas</h1>
              <p className="text-sm text-slate-600">Vista completa con filtros</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={descargarExcel}
              disabled={descargandoExcel}
              className="flex items-center gap-2 px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl transition-colors disabled:opacity-50"
            >
              {descargandoExcel ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
              {descargandoExcel ? 'Exportando...' : 'Descargar Excel'}
            </button>
            <button onClick={cargarDatos} className="flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors">
              <RefreshCw className="w-4 h-4" />
              Actualizar
            </button>
          </div>
        </div>
      </header>

      <main className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 ${seleccionadas.size > 0 ? 'pb-24' : ''}`}>
        {/* Stats Cards */}
        <div className="grid grid-cols-4 gap-4 mb-6">
          <button
            onClick={() => { setFiltroEstado('todos'); setSeleccionadas(new Set()); setPagination(p => ({ ...p, page: 1 })); }}
            className={`p-4 rounded-xl border-2 transition-all ${filtroEstado === 'todos' ? 'border-primary-500 bg-primary-50' : 'border-slate-200 bg-white hover:border-slate-300'}`}
          >
            <div className="text-3xl font-bold text-slate-900">{stats.total}</div>
            <div className="text-sm text-slate-600">Total</div>
          </button>
          <button
            onClick={() => { setFiltroEstado('conductor_identificado'); setSeleccionadas(new Set()); setPagination(p => ({ ...p, page: 1 })); }}
            className={`p-4 rounded-xl border-2 transition-all ${filtroEstado === 'conductor_identificado' ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 bg-white hover:border-emerald-300'}`}
          >
            <div className="text-3xl font-bold text-emerald-600">{stats.identificadas}</div>
            <div className="text-sm text-slate-600">Identificadas</div>
          </button>
          <button
            onClick={() => { setFiltroEstado('pendiente_identificacion'); setSeleccionadas(new Set()); setPagination(p => ({ ...p, page: 1 })); }}
            className={`p-4 rounded-xl border-2 transition-all ${filtroEstado === 'pendiente_identificacion' ? 'border-amber-500 bg-amber-50' : 'border-slate-200 bg-white hover:border-amber-300'}`}
          >
            <div className="text-3xl font-bold text-amber-600">{stats.pendientes}</div>
            <div className="text-sm text-slate-600">Pendientes</div>
          </button>
          <button
            onClick={() => { setFiltroEstado('comunicado_organismo'); setSeleccionadas(new Set()); setPagination(p => ({ ...p, page: 1 })); }}
            className={`p-4 rounded-xl border-2 transition-all ${filtroEstado === 'comunicado_organismo' ? 'border-blue-500 bg-blue-50' : 'border-slate-200 bg-white hover:border-blue-300'}`}
          >
            <div className="text-3xl font-bold text-blue-600">{stats.comunicadas}</div>
            <div className="text-sm text-slate-600">Comunicadas</div>
          </button>
        </div>

        {/* Buscador principal */}
        <div className="bg-white rounded-xl shadow-soft p-4 mb-4">
          <div className="relative">
            <Search className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Buscar por matrícula, expediente, conductor, DNI, organismo..."
              value={busqueda}
              onChange={(e) => { setBusqueda(e.target.value); setSeleccionadas(new Set()); }}
              className="w-full pl-12 pr-12 py-3 text-lg border-2 border-slate-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              autoFocus
            />
            {busqueda && (
              <button
                onClick={() => setBusqueda('')}
                className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-slate-100 rounded-full"
              >
                <X className="w-4 h-4 text-slate-400" />
              </button>
            )}
          </div>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-xl shadow-soft p-4 mb-6">
          <div className="flex items-center gap-4">
            <Filter className="w-5 h-5 text-slate-400" />
            <select
              value={filtroEmpresa}
              onChange={(e) => { setFiltroEmpresa(e.target.value); setSeleccionadas(new Set()); setPagination(p => ({ ...p, page: 1 })); }}
              className="flex-1 px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary-500"
            >
              <option value="">Todas las empresas</option>
              {empresas.map(e => (
                <option key={e.id} value={e.id}>{e.nombre}</option>
              ))}
            </select>
            <select
              value={filtroDocs}
              onChange={(e) => { setFiltroDocs(e.target.value); setSeleccionadas(new Set()); setPagination(p => ({ ...p, page: 1 })); }}
              className="px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary-500"
            >
              <option value="">Todos los docs</option>
              <option value="comunicadas">Comunicadas</option>
              <option value="completos">Docs completos (3/3)</option>
              <option value="incompletos">Docs incompletos</option>
              <option value="con_notificacion">Con notificación</option>
              <option value="sin_notificacion">Sin notificación</option>
              <option value="con_escrito">Con escrito</option>
              <option value="sin_escrito">Sin escrito</option>
              <option value="con_justificante">Con justificante</option>
              <option value="sin_justificante">Sin justificante</option>
            </select>
            {(busqueda || filtroEmpresa || filtroEstado !== 'todos' || filtroDocs) && (
              <button
                onClick={() => { setBusqueda(''); setFiltroEmpresa(''); setFiltroEstado('todos'); setFiltroDocs(''); setSeleccionadas(new Set()); setPagination(p => ({ ...p, page: 1 })); }}
                className="px-4 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              >
                Limpiar filtros
              </button>
            )}
          </div>
        </div>

        {/* Tabla de Multas */}
        <div className="bg-white rounded-xl shadow-soft overflow-hidden">
          <div className="overflow-auto max-h-[75vh]">
            <table className="w-full">
              <thead className="bg-slate-50 border-b border-slate-200 sticky top-0 z-10">
                <tr>
                  <th className="py-3 px-2 w-10">
                    {multasFiltradas.length > 0 && (
                      <input
                        type="checkbox"
                        checked={multasFiltradas.length > 0 && multasFiltradas.every(m => seleccionadas.has(m.id))}
                        onChange={toggleTodas}
                        className="w-4 h-4 text-blue-600 rounded border-slate-300 focus:ring-blue-500 cursor-pointer"
                        title={`Seleccionar todas (${multasFiltradas.length})`}
                      />
                    )}
                  </th>
                  {[
                    ['id', 'ID', 'px-3'], ['estado', 'Estado', 'px-4'], ['numero_expediente', 'Expediente', 'px-4'],
                    ['matricula', 'Matricula', 'px-4'], ['empresa_nombre', 'Empresa', 'px-4'],
                    ['fecha_infraccion', 'F. Denuncia', 'px-4'], ['fecha_comunicacion_organismo', 'F. Comunic.', 'px-4'],
                    ['importe_multa', 'Importe', 'px-4'], ['conductor_nombre', 'Identificado', 'px-4'],
                    ['tipo_identificacion', 'Tipo ID', 'px-4']
                  ].map(([col, label, px]) => (
                    <th key={col} className={`text-left py-3 ${px} font-medium text-slate-700 cursor-pointer hover:text-primary-600 select-none`}
                      onClick={() => { if (ordenCol === col) { setOrdenDir(d => d === 'ASC' ? 'DESC' : 'ASC'); } else { setOrdenCol(col); setOrdenDir('ASC'); } setPagination(p => ({...p, page: 1})); }}>
                      {label} {ordenCol === col ? (ordenDir === 'ASC' ? '▲' : '▼') : ''}
                    </th>
                  ))}
                  <th className="text-left py-3 px-2 font-medium text-slate-700" title="Documentos: Notificación / Escrito / Justificante">Docs</th>
                  <th className="text-left py-3 px-4 font-medium text-slate-700">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {multasFiltradas.length === 0 ? (
                  <tr>
                    <td colSpan="12" className="py-8 text-center text-slate-500">
                      No hay multas que coincidan con los filtros
                    </td>
                  </tr>
                ) : (
                  multasFiltradas.map((multa) => {
                    const badge = getEstadoBadge(multa.estado);
                    const Icon = badge.icon;
                    return (
                      <tr key={multa.id} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                        <td className="py-3 px-2 w-10">
                          <input
                            type="checkbox"
                            checked={seleccionadas.has(multa.id)}
                            onChange={() => toggleSeleccion(multa.id)}
                            className="w-4 h-4 text-blue-600 rounded border-slate-300 focus:ring-blue-500 cursor-pointer"
                          />
                        </td>
                        <td className="py-3 px-3 text-xs text-slate-400 font-mono">{multa.id}</td>
                        <td className="py-3 px-4">
                          <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}>
                            <Icon className="w-3.5 h-3.5" />
                            {badge.label}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <div className="font-medium text-slate-900">{multa.numero_expediente || '-'}</div>
                          {multa.metadata?.numero_notificacion &&
                           multa.metadata.numero_notificacion !== multa.numero_expediente && (
                            <div className="text-xs text-slate-400">Notif: {multa.metadata.numero_notificacion}</div>
                          )}
                          {!multa.datos_pdf_completos && (
                            <span className="inline-block mt-1 px-1.5 py-0.5 bg-orange-100 text-orange-700 text-[10px] font-medium rounded">Incompleta</span>
                          )}
                        </td>
                        <td className="py-3 px-4">
                          <span className="flex items-center gap-1.5 text-slate-900">
                            <Car className="w-4 h-4 text-slate-400" />
                            {multa.matricula}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <span className="flex items-center gap-1.5 text-slate-700">
                            <Building className="w-4 h-4 text-slate-400" />
                            {multa.empresa_nombre || '-'}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <span className="flex items-center gap-1.5 text-slate-700">
                            <Calendar className="w-4 h-4 text-slate-400" />
                            {formatDate(multa.fecha_infraccion)}
                          </span>
                        </td>
                        <td className="py-3 px-4 text-sm text-slate-600">
                          {multa.fecha_comunicacion_organismo ? formatDate(multa.fecha_comunicacion_organismo) : <span className="text-slate-300">-</span>}
                        </td>
                        <td className="py-3 px-4">
                          <span className="flex items-center gap-1.5 font-medium text-slate-900">
                            <Euro className="w-4 h-4 text-slate-400" />
                            {formatCurrency(multa.importe_multa)}
                          </span>
                        </td>
                        <td className="py-3 px-4 text-slate-700">
                          <div className="flex items-center gap-1">
                            {multa.tipo_identificacion === 'empresa_cesionaria' ? (
                              <div>
                                <p className="font-medium">{multa.empresa_cesionaria_razon_social || '-'}</p>
                                <p className="text-xs text-slate-500">{multa.empresa_cesionaria_cif}</p>
                              </div>
                            ) : (
                              <div>
                                <p className="font-medium">{multa.conductor_nombre || '-'}</p>
                                {multa.conductor_dni && <p className="text-xs text-slate-500">{multa.conductor_dni}</p>}
                              </div>
                            )}
                            {multa.estado !== 'comunicado_organismo' && (
                              <button
                                onClick={() => abrirIdentificacionModal(multa)}
                                className="p-1 text-slate-400 hover:text-blue-600 transition-colors"
                                title="Cambiar identificación"
                              >
                                <Edit3 className="w-3 h-3" />
                              </button>
                            )}
                          </div>
                        </td>
                        <td className="py-3 px-4">
                          {multa.tipo_identificacion === 'empresa_cesionaria' && (
                            <span className="px-2 py-1 bg-emerald-100 text-emerald-700 text-xs rounded-full">Auto</span>
                          )}
                          {multa.tipo_identificacion === 'conductor' && (
                            <span className="px-2 py-1 bg-emerald-100 text-emerald-700 text-xs rounded-full">Auto</span>
                          )}
                          {multa.tipo_identificacion === 'manual' && (
                            <span className="px-2 py-1 bg-amber-100 text-amber-700 text-xs rounded-full">Manual</span>
                          )}
                          {multa.tipo_identificacion === 'pendiente' && (
                            <span className="px-2 py-1 bg-slate-100 text-slate-500 text-xs rounded-full">Pendiente</span>
                          )}
                          {!multa.tipo_identificacion && (
                            <span className="text-slate-400">-</span>
                          )}
                        </td>
                        <td className="py-3 px-2">
                          <div className="flex items-center gap-0.5" title={`N:${multa.notificacion_pdf_url ? '✓' : '✗'} E:${multa.escrito_pdf_url ? '✓' : '✗'} J:${multa.justificante_url ? '✓' : '✗'}`}>
                            <span className={`w-2 h-2 rounded-full ${multa.notificacion_pdf_url ? 'bg-emerald-500' : 'bg-slate-300'}`} />
                            <span className={`w-2 h-2 rounded-full ${multa.escrito_pdf_url ? 'bg-blue-500' : 'bg-slate-300'}`} />
                            <span className={`w-2 h-2 rounded-full ${multa.justificante_url ? 'bg-emerald-500' : 'bg-slate-300'}`} />
                          </div>
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex items-center gap-2">
                            {multa.notificacion_pdf_url ? (
                              <button
                                onClick={() => descargarNotificacionPdf(multa.id)}
                                disabled={descargandoNotificacion[multa.id]}
                                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-600 text-white text-xs font-medium rounded-lg hover:bg-slate-700 transition-colors disabled:opacity-50"
                                title="Descargar PDF original de notificación DGT"
                              >
                                {descargandoNotificacion[multa.id] ? (
                                  <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                ) : (
                                  <FileText className="w-3.5 h-3.5" />
                                )}
                                {descargandoNotificacion[multa.id] ? '...' : 'PDF'}
                              </button>
                            ) : (
                              <label
                                className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg cursor-pointer transition-colors ${subiendoPdf[multa.id] ? 'bg-slate-200 text-slate-400' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
                                title="Adjuntar PDF de la notificación"
                              >
                                {subiendoPdf[multa.id] ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
                                {subiendoPdf[multa.id] ? '...' : 'PDF'}
                                <input type="file" className="hidden" accept=".pdf,.png,.jpg,.jpeg" disabled={subiendoPdf[multa.id]}
                                  onChange={(e) => { if (e.target.files[0]) subirNotificacionPdf(multa.id, e.target.files[0]); e.target.value = ''; }} />
                              </label>
                            )}
                            {multa.boe_pdf_s3_url && (
                              <button
                                onClick={() => descargarBoePdf(multa.id)}
                                disabled={descargandoBoe[multa.id]}
                                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-600 text-white text-xs font-medium rounded-lg hover:bg-amber-700 transition-colors disabled:opacity-50"
                                title="Descargar PDF original del BOE"
                              >
                                {descargandoBoe[multa.id] ? (
                                  <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                ) : (
                                  <Newspaper className="w-3.5 h-3.5" />
                                )}
                                {descargandoBoe[multa.id] ? '...' : 'BOE'}
                              </button>
                            )}
                            {multa.escrito_pdf_url && (
                              <button
                                onClick={() => descargarEscrito(multa.id)}
                                disabled={descargandoEscrito[multa.id]}
                                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
                                title="Descargar escrito de identificación"
                              >
                                {descargandoEscrito[multa.id] ? (
                                  <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                ) : (
                                  <Edit3 className="w-3.5 h-3.5" />
                                )}
                                Escrito
                              </button>
                            )}
                            {multa.estado === 'comunicado_organismo' && (
                              <button
                                onClick={() => descargarJustificante(multa.id, multa.numero_expediente)}
                                disabled={descargando[multa.id]}
                                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 text-white text-xs font-medium rounded-lg hover:bg-emerald-700 transition-colors disabled:opacity-50"
                              >
                                {descargando[multa.id] ? (
                                  <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                ) : (
                                  <Download className="w-3.5 h-3.5" />
                                )}
                                {descargando[multa.id] ? '...' : 'Descargar'}
                              </button>
                            )}
                            {/* Antes solo aparecía si los datos estaban INCOMPLETOS, así que un importe
                                mal leído del PDF (que marca la multa como "completa") no se podía corregir.
                                Ahora permite editar siempre que no esté comunicada al organismo. */}
                            {multa.estado !== 'comunicado_organismo' && (
                              <button
                                onClick={() => abrirModal(multa)}
                                className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-white text-xs font-medium rounded-lg transition-colors ${
                                  multa.datos_pdf_completos ? 'bg-slate-500 hover:bg-slate-600' : 'bg-orange-500 hover:bg-orange-600'
                                }`}
                                title={multa.datos_pdf_completos ? 'Editar importe y datos de la multa' : 'Completar los datos que faltan'}
                              >
                                <Edit3 className="w-3.5 h-3.5" />
                                {multa.datos_pdf_completos ? 'Editar datos' : 'Completar'}
                              </button>
                            )}
                            {multa.datos_pdf_completos && multa.estado === 'conductor_identificado' && (
                              <>
                                <button
                                  onClick={() => enviarAlOrganismo(multa)}
                                  disabled={!!enviandoOrganismo[multa.id]}
                                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
                                  title="Enviar al organismo via certificado digital (automatico)"
                                >
                                  {enviandoOrganismo[multa.id] === 'enviando' ? (
                                    <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                  ) : enviandoOrganismo[multa.id] === 'enviado' ? (
                                    <CheckCircle className="w-3.5 h-3.5" />
                                  ) : (
                                    <Send className="w-3.5 h-3.5" />
                                  )}
                                  {enviandoOrganismo[multa.id] === 'enviando' ? 'Enviando...' : enviandoOrganismo[multa.id] === 'enviado' ? 'Enviado' : 'Enviar'}
                                </button>
                                <button
                                  onClick={() => abrirComunicarModal(multa)}
                                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-500 text-white text-xs font-medium rounded-lg hover:bg-amber-600 transition-colors"
                                  title="Marcar como comunicada manualmente (ya comunicaste en la web del organismo)"
                                >
                                  <Upload className="w-3.5 h-3.5" />
                                  Manual
                                </button>
                              </>
                            )}
                            <button
                              onClick={() => abrirHistorial(multa)}
                              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 text-slate-600 text-xs font-medium rounded-lg hover:bg-slate-200 transition-colors"
                            >
                              <History className="w-3.5 h-3.5" />
                              Log
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="px-4 py-3 bg-slate-50 border-t border-slate-200 flex items-center justify-between">
            <span className="text-sm text-slate-600">
              Mostrando {multas.length} de {pagination.total} multas
              {pagination.totalPages > 1 && ` (pág. ${pagination.page} de ${pagination.totalPages})`}
            </span>
            {pagination.totalPages > 1 && (
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setPagination(p => ({ ...p, page: 1 }))}
                  disabled={pagination.page <= 1 || loading}
                  className="px-2 py-1 text-xs font-medium rounded border border-slate-300 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  «
                </button>
                <button
                  onClick={() => setPagination(p => ({ ...p, page: Math.max(1, p.page - 1) }))}
                  disabled={pagination.page <= 1 || loading}
                  className="px-3 py-1 text-sm font-medium rounded border border-slate-300 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  Anterior
                </button>
                <span className="text-sm font-medium text-slate-700 px-2">
                  {pagination.page} / {pagination.totalPages}
                </span>
                <button
                  onClick={() => setPagination(p => ({ ...p, page: Math.min(p.totalPages, p.page + 1) }))}
                  disabled={pagination.page >= pagination.totalPages || loading}
                  className="px-3 py-1 text-sm font-medium rounded border border-slate-300 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  Siguiente
                </button>
                <button
                  onClick={() => setPagination(p => ({ ...p, page: p.totalPages }))}
                  disabled={pagination.page >= pagination.totalPages || loading}
                  className="px-2 py-1 text-xs font-medium rounded border border-slate-300 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  »
                </button>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* Barra flotante de seleccion masiva */}
      {seleccionadas.size > 0 && (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-blue-500 shadow-lg z-40">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <span className="inline-flex items-center gap-2 text-sm font-medium text-slate-900">
                <CheckSquare className="w-5 h-5 text-blue-600" />
                {seleccionadas.size} seleccionada{seleccionadas.size !== 1 ? 's' : ''}
              </span>
              <button
                onClick={() => setSeleccionadas(new Set())}
                className="text-sm text-slate-500 hover:text-slate-700 underline"
              >
                Deseleccionar todo
              </button>
            </div>
            <button
              onClick={() => { setComunicarMasivoModal(true); setComunicarMasivoForm({ observaciones: '' }); }}
              className="inline-flex items-center gap-2 px-5 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Send className="w-4 h-4" />
              Comunicar seleccionadas ({seleccionadas.size})
            </button>
          </div>
        </div>
      )}

      {/* Modal comunicacion masiva */}
      {comunicarMasivoModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Comunicacion masiva</h2>
                <p className="text-sm text-slate-500">Se comunicaran {seleccionadas.size} multa{seleccionadas.size !== 1 ? 's' : ''}</p>
              </div>
              <button onClick={() => setComunicarMasivoModal(false)} className="p-2 hover:bg-slate-100 rounded-lg" disabled={comunicandoMasivo}>
                <X className="w-5 h-5 text-slate-500" />
              </button>
            </div>

            <div className="p-6">
              {/* Lista de multas seleccionadas */}
              <div className="bg-slate-50 rounded-lg p-4 mb-4">
                <p className="text-sm font-medium text-slate-700 mb-2">Multas seleccionadas:</p>
                <ul className="space-y-1 text-sm text-slate-600">
                  {multas.filter(m => seleccionadas.has(m.id)).slice(0, 5).map(m => (
                    <li key={m.id} className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                      <span className="font-mono text-xs">{m.numero_expediente || '-'}</span>
                      <span className="text-slate-400">-</span>
                      <span>{m.matricula}</span>
                      <span className="text-slate-400">({m.empresa_nombre})</span>
                    </li>
                  ))}
                  {seleccionadas.size > 5 && (
                    <li className="text-slate-400 italic">...y {seleccionadas.size - 5} mas</li>
                  )}
                </ul>
              </div>

              {/* Aviso */}
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
                <p className="text-sm text-amber-800">
                  <strong>Atencion:</strong> Se generara un justificante PDF individual por cada multa. Asegurate de haber realizado la comunicacion en la web del organismo para todas las multas seleccionadas.
                </p>
              </div>

              {/* Observaciones */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Observaciones (opcional, se aplica a todas)
                </label>
                <textarea
                  value={comunicarMasivoForm.observaciones}
                  onChange={(e) => setComunicarMasivoForm({ observaciones: e.target.value })}
                  className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  rows="3"
                  placeholder="Notas sobre la comunicacion realizada"
                  disabled={comunicandoMasivo}
                />
              </div>

              {/* Botones */}
              <div className="flex gap-3 mt-6 pt-4 border-t border-slate-200">
                <button
                  onClick={() => setComunicarMasivoModal(false)}
                  disabled={comunicandoMasivo}
                  className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors disabled:opacity-50"
                >
                  Cancelar
                </button>
                <button
                  onClick={comunicarMasivo}
                  disabled={comunicandoMasivo}
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
                >
                  {comunicandoMasivo ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <Send className="w-4 h-4" />
                  )}
                  {comunicandoMasivo ? 'Comunicando...' : `Confirmar (${seleccionadas.size} multas)`}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal comunicar manual */}
      {comunicarModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Registrar comunicacion manual</h2>
                <p className="text-sm text-slate-500">Exp: {comunicarModal.numero_expediente} - {comunicarModal.matricula}</p>
              </div>
              <button onClick={() => setComunicarModal(null)} className="p-2 hover:bg-slate-100 rounded-lg" disabled={comunicando}>
                <X className="w-5 h-5 text-slate-500" />
              </button>
            </div>

            <div className="p-6">
              {/* Aviso importante */}
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                <p className="text-sm text-red-800">
                  <strong>IMPORTANTE:</strong> Usa esta opcion SOLO si ya has realizado la comunicacion en la web del organismo manualmente. Esta accion NO envia nada al organismo, solo marca la multa como comunicada en el sistema.
                </p>
                <p className="text-sm text-red-700 mt-2">
                  Si quieres enviar la comunicacion al organismo automaticamente, cierra este modal y usa el boton <strong>"Enviar"</strong> (azul).
                </p>
              </div>

              {/* Datos de referencia */}
              <div className="bg-slate-50 rounded-lg p-4 mb-4">
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <span className="text-slate-500">Empresa:</span>
                    <span className="ml-2 font-medium">{comunicarModal.empresa_nombre}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Fecha:</span>
                    <span className="ml-2 font-medium">{formatDate(comunicarModal.fecha_infraccion)}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Identificado:</span>
                    <span className="ml-2 font-medium">
                      {comunicarModal.tipo_identificacion === 'empresa_cesionaria'
                        ? `${comunicarModal.empresa_cesionaria_razon_social} (${comunicarModal.empresa_cesionaria_cif})`
                        : comunicarModal.conductor_nombre || '-'}
                    </span>
                  </div>
                  <div>
                    <span className="text-slate-500">Organismo:</span>
                    <span className="ml-2 font-medium">{comunicarModal.organismo_emisor || 'N/A'}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Importe:</span>
                    <span className="ml-2 font-medium">{formatCurrency(comunicarModal.importe_multa)}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Estado:</span>
                    <span className="ml-2 font-medium text-emerald-600">Conductor identificado</span>
                  </div>
                </div>
              </div>

              {/* Formulario */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Justificante del organismo (recomendado)
                  </label>
                  <div className="relative">
                    <input
                      type="file"
                      accept=".pdf,.png,.jpg,.jpeg"
                      onChange={(e) => setComunicarArchivo(e.target.files[0] || null)}
                      className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 text-sm file:mr-4 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-amber-50 file:text-amber-700 hover:file:bg-amber-100"
                      disabled={comunicando}
                    />
                  </div>
                  <p className="text-xs text-slate-500 mt-1">
                    {comunicarArchivo
                      ? `Archivo seleccionado: ${comunicarArchivo.name}`
                      : 'Sube el PDF o captura de pantalla del justificante del organismo. Si no subes archivo, se generara un PDF interno.'}
                  </p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Numero de registro (opcional)
                  </label>
                  <input
                    type="text"
                    value={comunicarForm.numero_registro}
                    onChange={(e) => setComunicarForm({ ...comunicarForm, numero_registro: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                    placeholder="Numero de registro del organismo"
                    disabled={comunicando}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Observaciones (opcional)
                  </label>
                  <textarea
                    value={comunicarForm.observaciones}
                    onChange={(e) => setComunicarForm({ ...comunicarForm, observaciones: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                    rows="3"
                    placeholder="Notas sobre la comunicacion realizada"
                    disabled={comunicando}
                  />
                </div>
              </div>

              {/* Botones */}
              <div className="flex gap-3 mt-6 pt-4 border-t border-slate-200">
                <button
                  onClick={() => setComunicarModal(null)}
                  disabled={comunicando}
                  className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors disabled:opacity-50"
                >
                  Cancelar
                </button>
                <button
                  onClick={comunicarManual}
                  disabled={comunicando}
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors disabled:opacity-50"
                >
                  {comunicando ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <Upload className="w-4 h-4" />
                  )}
                  {comunicando ? 'Registrando...' : 'Confirmar comunicacion manual'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal historial */}
      {historialModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">
                  Historial - {historialModal.numero_expediente || 'Sin expediente'}
                </h2>
                <p className="text-sm text-slate-500">{historialModal.matricula}</p>
              </div>
              <div className="flex items-center gap-2">
                <label className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg cursor-pointer transition-colors ${subiendoDocumento ? 'bg-slate-100 text-slate-400' : 'bg-blue-50 text-blue-600 hover:bg-blue-100'}`}>
                  {subiendoDocumento ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
                  {subiendoDocumento ? 'Subiendo...' : 'Adjuntar'}
                  <input type="file" className="hidden" accept=".pdf,.png,.jpg,.jpeg" disabled={subiendoDocumento}
                    onChange={(e) => { if (e.target.files[0]) subirDocumentoHistorial(e.target.files[0]); e.target.value = ''; }} />
                </label>
                <button onClick={() => setHistorialModal(null)} className="p-2 hover:bg-slate-100 rounded-lg">
                  <X className="w-5 h-5 text-slate-500" />
                </button>
              </div>
            </div>

            <div className="p-6">
              {/* Datos de referencia */}
              <div className="bg-slate-50 rounded-lg p-4 mb-6">
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <span className="text-slate-500">Empresa:</span>
                    <span className="ml-2 font-medium">{historialModal.empresa_nombre || '-'}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Estado:</span>
                    <span className="ml-2 font-medium">{getEstadoBadge(historialModal.estado).label}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Fecha:</span>
                    <span className="ml-2 font-medium">{formatDate(historialModal.fecha_infraccion)}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Importe:</span>
                    <span className="ml-2 font-medium">{formatCurrency(historialModal.importe_multa)}</span>
                  </div>
                </div>
              </div>

              {/* Panel de documentos */}
              <div className="mb-6">
                <h3 className="text-sm font-semibold text-slate-700 mb-3">Documentos</h3>
                <div className="grid grid-cols-3 gap-3">
                  <div className={`p-3 rounded-lg border-2 ${historialModal.notificacion_pdf_url ? 'border-emerald-200 bg-emerald-50' : 'border-slate-200 bg-slate-50'}`}>
                    <div className="flex items-center gap-2 mb-1">
                      <FileText className={`w-4 h-4 ${historialModal.notificacion_pdf_url ? 'text-emerald-600' : 'text-slate-400'}`} />
                      <span className="text-xs font-medium text-slate-700">Notificación</span>
                    </div>
                    <p className="text-[10px] text-slate-500 mb-2">PDF original del organismo</p>
                    {historialModal.notificacion_pdf_url ? (
                      <button onClick={() => descargarNotificacionPdf(historialModal.id)} disabled={descargandoNotificacion[historialModal.id]}
                        className="w-full text-xs px-2 py-1 bg-emerald-600 text-white rounded hover:bg-emerald-700 disabled:opacity-50">
                        {descargandoNotificacion[historialModal.id] ? 'Descargando...' : 'Descargar'}
                      </button>
                    ) : (
                      <span className="text-[10px] text-slate-400">No disponible</span>
                    )}
                  </div>
                  <div className={`p-3 rounded-lg border-2 ${historialModal.escrito_pdf_url ? 'border-blue-200 bg-blue-50' : 'border-slate-200 bg-slate-50'}`}>
                    <div className="flex items-center gap-2 mb-1">
                      <Edit3 className={`w-4 h-4 ${historialModal.escrito_pdf_url ? 'text-blue-600' : 'text-slate-400'}`} />
                      <span className="text-xs font-medium text-slate-700">Escrito</span>
                    </div>
                    <p className="text-[10px] text-slate-500 mb-2">Escrito de identificación</p>
                    {historialModal.escrito_pdf_url ? (
                      <button onClick={() => descargarEscrito(historialModal.id)} disabled={descargandoEscrito[historialModal.id]}
                        className="w-full text-xs px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50">
                        {descargandoEscrito[historialModal.id] ? 'Descargando...' : 'Descargar'}
                      </button>
                    ) : (
                      <span className="text-[10px] text-slate-400">No disponible</span>
                    )}
                  </div>
                  <div className={`p-3 rounded-lg border-2 ${historialModal.justificante_url ? 'border-emerald-200 bg-emerald-50' : 'border-slate-200 bg-slate-50'}`}>
                    <div className="flex items-center gap-2 mb-1">
                      <CheckCircle className={`w-4 h-4 ${historialModal.justificante_url ? 'text-emerald-600' : 'text-slate-400'}`} />
                      <span className="text-xs font-medium text-slate-700">Justificante</span>
                    </div>
                    <p className="text-[10px] text-slate-500 mb-2">Justificante de presentación</p>
                    {historialModal.justificante_url ? (
                      <button onClick={() => descargarJustificante(historialModal.id, historialModal.numero_expediente)} disabled={descargando[historialModal.id]}
                        className="w-full text-xs px-2 py-1 bg-emerald-600 text-white rounded hover:bg-emerald-700 disabled:opacity-50">
                        {descargando[historialModal.id] ? 'Descargando...' : 'Descargar'}
                      </button>
                    ) : (
                      <span className="text-[10px] text-slate-400">No disponible</span>
                    )}
                  </div>
                </div>
              </div>

              {/* Timeline */}
              {cargandoHistorial ? (
                <div className="flex items-center justify-center py-12">
                  <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
                  <span className="ml-2 text-slate-500">Cargando historial...</span>
                </div>
              ) : historial.length === 0 ? (
                <div className="text-center py-12">
                  <History className="w-10 h-10 text-slate-300 mx-auto mb-3" />
                  <p className="text-slate-500">No hay registros de actividad para esta multa</p>
                </div>
              ) : (
                <div className="space-y-0">
                  {historial.map((entry, idx) => {
                    const { icon: EntryIcon, color, bg } = getHistorialIcon(entry.tipo);
                    return (
                      <div key={entry.id || idx} className="relative flex gap-4">
                        {/* Vertical line */}
                        {idx < historial.length - 1 && (
                          <div className="absolute left-[17px] top-10 bottom-0 w-px bg-slate-200" />
                        )}
                        {/* Icon */}
                        <div className={`flex-shrink-0 w-9 h-9 rounded-full ${bg} flex items-center justify-center z-10`}>
                          <EntryIcon className={`w-4 h-4 ${color}`} />
                        </div>
                        {/* Content */}
                        <div className="flex-1 pb-6">
                          <div className="flex items-start justify-between gap-2">
                            <div>
                              <p className="text-sm font-medium text-slate-900">{entry.accion}</p>
                              <p className="text-xs text-slate-400 mt-0.5">{formatDateTime(entry.created_at)}</p>
                            </div>
                            <div className="flex items-center gap-2 flex-shrink-0">
                              {entry.resultado && (
                                <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${getResultadoBadge(entry.resultado)}`}>
                                  {entry.resultado}
                                </span>
                              )}
                            </div>
                          </div>
                          {entry.usuario_nombre && (
                            <p className="text-xs text-slate-500 mt-1">Por: {entry.usuario_nombre}</p>
                          )}
                          {/* Detalles JSONB */}
                          {entry.detalles && Object.keys(entry.detalles).length > 0 && (
                            <div className="mt-2 bg-slate-50 rounded-lg p-3 text-xs">
                              {Object.entries(entry.detalles).map(([key, value]) => (
                                value != null && value !== '' && (
                                  <div key={key} className="flex gap-2 py-0.5">
                                    <span className="text-slate-400 font-mono">{key}:</span>
                                    <span className="text-slate-700 break-all">
                                      {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                    </span>
                                  </div>
                                )
                              ))}
                            </div>
                          )}
                          {/* Plan de solucion */}
                          {entry.plan_solucion && (
                            <div className="mt-2 bg-amber-50 border border-amber-200 rounded-lg p-3">
                              <p className="text-xs font-medium text-amber-700 mb-1">Plan de solucion:</p>
                              <p className="text-xs text-amber-800 whitespace-pre-wrap">{entry.plan_solucion}</p>
                            </div>
                          )}
                          {/* Documento adjunto */}
                          {entry.documento_download_url && (
                            <div className="mt-2 bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-center gap-3">
                              <FileText className="w-5 h-5 text-blue-500 flex-shrink-0" />
                              <div className="flex-1 min-w-0">
                                <p className="text-xs font-medium text-blue-900 truncate">{entry.documento_nombre || 'Documento'}</p>
                                {entry.documento_tipo && (
                                  <span className="inline-block mt-0.5 px-1.5 py-0.5 bg-blue-100 text-blue-600 rounded text-[10px] font-medium">{entry.documento_tipo}</span>
                                )}
                              </div>
                              <a href={entry.documento_download_url} target="_blank" rel="noopener noreferrer"
                                className="flex items-center gap-1 px-2.5 py-1 bg-blue-600 text-white rounded-md text-xs font-medium hover:bg-blue-700 transition-colors flex-shrink-0">
                                <Download className="w-3 h-3" /> Descargar
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Cerrar */}
              <div className="mt-4 pt-4 border-t border-slate-200">
                <button
                  onClick={() => setHistorialModal(null)}
                  className="w-full px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal completar datos */}
      {modalMulta && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Completar datos de multa</h2>
                <p className="text-sm text-slate-500">Exp: {modalMulta.numero_expediente} - {modalMulta.matricula}</p>
              </div>
              <button onClick={cerrarModal} className="p-2 hover:bg-slate-100 rounded-lg">
                <X className="w-5 h-5 text-slate-500" />
              </button>
            </div>

            <div className="p-6">
              {/* Datos de referencia */}
              <div className="bg-slate-50 rounded-lg p-4 mb-6">
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <span className="text-slate-500">Empresa:</span>
                    <span className="ml-2 font-medium">{modalMulta.empresa_nombre}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Fecha:</span>
                    <span className="ml-2 font-medium">{formatDate(modalMulta.fecha_infraccion)}</span>
                  </div>
                  <div>
                    <span className="text-slate-500">Identificado:</span>
                    <span className="ml-2 font-medium">
                      {modalMulta.tipo_identificacion === 'empresa_cesionaria'
                        ? `${modalMulta.empresa_cesionaria_razon_social} (${modalMulta.empresa_cesionaria_cif})`
                        : modalMulta.conductor_nombre || 'Sin identificar'}
                    </span>
                  </div>
                  <div>
                    <span className="text-slate-500">Organismo:</span>
                    <span className="ml-2 font-medium">{modalMulta.organismo_emisor || 'N/A'}</span>
                  </div>
                </div>
              </div>

              {/* Formulario */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Expediente completo (codigo notificacion)
                  </label>
                  <input
                    type="text"
                    value={datosForm.codigo_notificacion}
                    onChange={(e) => setDatosForm({...datosForm, codigo_notificacion: e.target.value})}
                    className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    placeholder="Ej: 280498734509 (12 digitos)"
                  />
                  <p className="mt-1 text-xs text-slate-400">Necesario para comunicar al organismo</p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">
                      Importe (EUR)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={datosForm.importe_multa}
                      onChange={(e) => setDatosForm({...datosForm, importe_multa: e.target.value})}
                      className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      placeholder="0.00"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">
                      Puntos
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="6"
                      value={datosForm.puntos}
                      onChange={(e) => setDatosForm({...datosForm, puntos: e.target.value})}
                      className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      placeholder="0"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Articulo
                  </label>
                  <input
                    type="text"
                    value={datosForm.articulo}
                    onChange={(e) => setDatosForm({...datosForm, articulo: e.target.value})}
                    className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    placeholder="Ej: Art. 18.2 RGC"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Concepto / Descripcion
                  </label>
                  <textarea
                    value={datosForm.concepto}
                    onChange={(e) => setDatosForm({...datosForm, concepto: e.target.value})}
                    className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    rows="3"
                    placeholder="Descripcion de la infraccion"
                  />
                </div>
              </div>

              {/* Botones */}
              <div className="flex gap-3 mt-6 pt-4 border-t border-slate-200">
                <button
                  onClick={cerrarModal}
                  className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={guardarDatos}
                  disabled={guardando}
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors disabled:opacity-50"
                >
                  {guardando ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <Save className="w-4 h-4" />
                  )}
                  {guardando ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {identificacionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold text-slate-800">Cambiar identificación</h3>
                <button onClick={() => setIdentificacionModal(null)} className="p-1 hover:bg-slate-100 rounded-full">
                  <X className="w-5 h-5" />
                </button>
              </div>

              <div className="bg-slate-50 rounded-lg p-3 mb-4 text-sm">
                <p><span className="text-slate-500">Multa:</span> <span className="font-medium">{identificacionModal.numero_expediente}</span></p>
                <p><span className="text-slate-500">Matrícula:</span> <span className="font-medium">{identificacionModal.matricula}</span></p>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Tipo de identificación</label>
                  <select
                    value={identificacionForm.tipo_identificacion}
                    onChange={(e) => setIdentificacionForm(prev => ({ ...prev, tipo_identificacion: e.target.value }))}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="conductor">Conductor (persona física)</option>
                    <option value="empresa_cesionaria">Empresa cesionaria (persona jurídica)</option>
                    <option value="otros">Otros (gestionada fuera de la plataforma)</option>
                  </select>
                </div>

                {/* Gestión externa: abonada, recurrida o tramitada fuera de la app.
                    Saca la multa de pendientes sin falsear una identificación. */}
                {identificacionForm.tipo_identificacion === 'otros' && (
                  <div className="space-y-3 border-t pt-3">
                    <p className="text-sm font-medium text-amber-700">Gestión fuera de la plataforma</p>
                    <p className="text-xs text-slate-500">
                      La multa dejará de figurar como pendiente y quedará registrada como gestionada externamente.
                      No se comunicará al organismo desde el sistema.
                    </p>
                    <div>
                      <label className="block text-xs text-slate-500 mb-1">Motivo *</label>
                      <select
                        value={identificacionForm.motivo_externo || ''}
                        onChange={(e) => setIdentificacionForm(prev => ({ ...prev, motivo_externo: e.target.value }))}
                        className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm"
                      >
                        <option value="">Selecciona un motivo…</option>
                        <option value="abonada">Abonada / pagada</option>
                        <option value="gestionada_externamente">Gestionada fuera de la plataforma</option>
                        <option value="vehiculo_no_flota">Vehículo que no pertenece a la flota</option>
                        <option value="recurrida">Recurrida</option>
                        <option value="duplicada">Duplicada / error de registro</option>
                        <option value="otro">Otro</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs text-slate-500 mb-1">Observaciones</label>
                      <textarea
                        value={identificacionForm.observaciones_externo || ''}
                        onChange={(e) => setIdentificacionForm(prev => ({ ...prev, observaciones_externo: e.target.value }))}
                        rows={2}
                        className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm"
                        placeholder="Ej: abonada por el cliente el 12/08/2026, justificante en carpeta compartida"
                      />
                    </div>
                  </div>
                )}

                {identificacionForm.tipo_identificacion === 'conductor' && (
                  <div className="space-y-3 border-t pt-3">
                    <p className="text-sm font-medium text-emerald-700">Datos persona física (conductor)</p>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">DNI / NIE *</label>
                        <input type="text" value={identificacionForm.conductor_dni}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, conductor_dni: e.target.value.toUpperCase() }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" placeholder="12345678A o X1234567L" />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">Nombre *</label>
                        <input type="text" value={identificacionForm.conductor_nombre}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, conductor_nombre: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">Primer apellido</label>
                        <input type="text" value={identificacionForm.conductor_apellido1}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, conductor_apellido1: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">Segundo apellido</label>
                        <input type="text" value={identificacionForm.conductor_apellido2}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, conductor_apellido2: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs text-slate-500 mb-1">Domicilio</label>
                      <input type="text" value={identificacionForm.conductor_direccion}
                        onChange={(e) => setIdentificacionForm(prev => ({ ...prev, conductor_direccion: e.target.value }))}
                        className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" placeholder="C/ Ejemplo 12, 3º A" />
                    </div>
                    <div className="grid grid-cols-3 gap-3">
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">C.P.</label>
                        <input type="text" value={identificacionForm.conductor_codigo_postal}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, conductor_codigo_postal: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" placeholder="28001" />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">Población</label>
                        <input type="text" value={identificacionForm.conductor_poblacion}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, conductor_poblacion: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">Provincia</label>
                        <input type="text" value={identificacionForm.conductor_provincia}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, conductor_provincia: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                      </div>
                    </div>
                  </div>
                )}

                {identificacionForm.tipo_identificacion === 'empresa_cesionaria' && (
                  <div className="space-y-3 border-t pt-3">
                    <p className="text-sm font-medium text-emerald-700">Datos empresa cesionaria</p>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">CIF *</label>
                        <input type="text" value={identificacionForm.empresa_cesionaria_cif}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, empresa_cesionaria_cif: e.target.value.toUpperCase() }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" placeholder="B12345678" />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">Nº contrato</label>
                        <input type="text" value={identificacionForm.empresa_cesionaria_num_contrato}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, empresa_cesionaria_num_contrato: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs text-slate-500 mb-1">Razón social *</label>
                      <input type="text" value={identificacionForm.empresa_cesionaria_razon_social}
                        onChange={(e) => setIdentificacionForm(prev => ({ ...prev, empresa_cesionaria_razon_social: e.target.value }))}
                        className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                    </div>
                    <div>
                      <label className="block text-xs text-slate-500 mb-1">Domicilio</label>
                      <input type="text" value={identificacionForm.empresa_cesionaria_domicilio}
                        onChange={(e) => setIdentificacionForm(prev => ({ ...prev, empresa_cesionaria_domicilio: e.target.value }))}
                        className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                    </div>
                    <div className="grid grid-cols-3 gap-3">
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">C.P.</label>
                        <input type="text" value={identificacionForm.empresa_cesionaria_codigo_postal}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, empresa_cesionaria_codigo_postal: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" placeholder="28001" />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">Población</label>
                        <input type="text" value={identificacionForm.empresa_cesionaria_poblacion}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, empresa_cesionaria_poblacion: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-500 mb-1">Provincia</label>
                        <input type="text" value={identificacionForm.empresa_cesionaria_provincia}
                          onChange={(e) => setIdentificacionForm(prev => ({ ...prev, empresa_cesionaria_provincia: e.target.value }))}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button onClick={() => setIdentificacionModal(null)}
                  className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
                  Cancelar
                </button>
                <button onClick={guardarIdentificacion} disabled={guardandoIdentificacion}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 flex items-center gap-2">
                  {guardandoIdentificacion ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                  {guardandoIdentificacion ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminMultas;
